module.exports = __webpack_public_path__ + "img/antonio.6477a812.jpg";